import ReactHtmlParser from "react-html-parser"
import Svg from "../../shared/_svgs/svg"

const AppPromoBanner = ({
  heading,
  headingDesktop,
  description,
  ctaText,
  promoImage,
  promoImageAltText,
  qrCodeImage,
  qrCodeImageAltText,
  link,
  linkLabel,
}) => {
  return (
    <div className="app-promo-banner">
      <div className="app-promo-banner__text">
        <div className="app-promo-banner__heading desktop rich-text">{ReactHtmlParser(headingDesktop)}</div>
        <div className="app-promo-banner__heading mobile rich-text">{ReactHtmlParser(heading)}</div>

        <div className="app-promo-banner__description rich-text">{ReactHtmlParser(description)}</div>

        <div className="app-promo-banner__scan-note rich-text">{ReactHtmlParser(ctaText)}</div>

        <a href={`${link}`} className="app-promo-banner__cta">
          <Svg iconName={"arrowright-slim"} isDecorative={true} /> <span className="text">{linkLabel}</span>
        </a>
      </div>
      <img
        tabIndex={qrCodeImageAltText ? "" : "-1"}
        aria-hidden={qrCodeImageAltText ? "false" : "true"}
        src={qrCodeImage}
        alt={qrCodeImageAltText || ""}
        className="app-promo-banner__qr"
      />
      <div className="app-promo-banner__media">
        <img
          tabIndex={promoImageAltText ? "" : "-1"}
          aria-hidden={promoImageAltText ? "false" : "true"}
          src={promoImage}
          alt={promoImageAltText || ""}
          className="app-promo-banner__promo"
        />
      </div>
    </div>
  )
}

export default AppPromoBanner
